import LectureLessonListPagingResultModelBase from '../_generated/modelBases/lecture-lesson-list-paging-result-model-base';

export default class LectureLessonListPagingResultModel extends LectureLessonListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
